const sortValues = {
  orderBy: "",
  order: "",
  page: 0,
  rowsPerPage: 10,
};

export default sortValues;
